(function () {
  angular.module("akitabox.ui.directives.importFileSelect", [
    "akitabox.core.services.file",
  ]);
})();
